<template>
  <v-card class="printable">
    <v-app-bar elevation="1" class="hide-if-print">
      <v-app-bar-title><v-icon>mdi-printer</v-icon> {{$vuetify.lang.t('Print Preview')}}</v-app-bar-title>
      <v-spacer></v-spacer>
      <v-icon @click.stop="$router.go(-1)">mdi-exit-to-app</v-icon>
    </v-app-bar>

    <router-view class="print-area"/>

    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn class="d-print-none" color="mevo" dark fixed bottom right @click="print" :disabled="disabled">
        <v-icon>mdi-printer</v-icon> {{'Print'}}
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { defineComponent } from 'vue';
import startCase from 'lodash/startCase';
import textCapitalize from '@/filters/text_formatters';
import Base from './Base.vue';

export default defineComponent({
  extends: Base,

  name: 'Print',

  metaInfo() {
    let title = 'Print Preview';

    if (this.player) {
      title = `${title} ${this.player.Id}`;
    }

    if (this.context) {
      title = `${title} - ${startCase(this.context)}`;
    }

    return {
      title,
    };
  },

  data() {
    return {
      disabled: false,
    };
  },

  created() {
    if (this.debug) {
      this.$log.debug('Print was created.');
    }
  },

  mounted() {
    if (this.debug) {
      this.$log.debug('Print was mounted.');
    }
  },

  computed: {
    dialogTitle() {
      return `Print Preview`;
    },
  },

  methods: {
    print() {
      window.print();
    },
  },
});
</script>

<style lang="scss">
@media screen {
  .hide-if-not-print {
    display: none;
  }
}

@media only print {
  .printable {
    overflow: visible !important;
    max-width: 8.5in;
    margin-left: auto;
    margin-right: auto;
  }

  .hide-if-print {
    display: none;
  }

  .print-header {
    td {
      padding-bottom: .5in;
    }
  }

  .print-header-logo {
    position: absolute;
    top: 0;
    left: 0;
  }
}
</style>
